import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Sidebar.css';
import { FaCalendarAlt, FaUserFriends, FaBars, FaTimes, FaCog, FaCashRegister, FaSignOutAlt, FaBoxes, FaChartBar, FaChevronLeft, FaChevronRight, FaNotesMedical, FaUsers } from 'react-icons/fa';
import { useAuth } from '../../hooks/useAuth';
import { Auth } from 'aws-amplify';
import { USER_GROUPS } from '../../config/permissions';
import { fetchTenant } from '../api';

function Sidebar() {
    const [isOpen, setIsOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [tenant, setTenant] = useState(null);
    const { user, userGroups } = useAuth();
    const navigate = useNavigate();
    const isAdmin = userGroups.includes(USER_GROUPS.ADMIN);
    const canAccessBooking = userGroups.includes(USER_GROUPS.ADMIN) || userGroups.includes(USER_GROUPS.ATENDIMENTOS) || userGroups.includes(USER_GROUPS.CAIXA) || userGroups.includes(USER_GROUPS.PROFISSIONAL);
    const canAccessPacientes = userGroups.includes(USER_GROUPS.ADMIN) || userGroups.includes(USER_GROUPS.ATENDIMENTOS) || userGroups.includes(USER_GROUPS.CAIXA);
    const canAccessCaixa = userGroups.includes(USER_GROUPS.ADMIN) || userGroups.includes(USER_GROUPS.CAIXA);
    const userEmail = user?.attributes?.email || user?.signInUserSession?.idToken?.payload?.email || user?.username;
    

    useEffect(() => {
        const getTenant = async () => {
            try {
                const tenantData = await fetchTenant();
                setTenant(tenantData);
            } catch (error) {
                console.error('Error fetching tenant data:', error);
            }
        };
        getTenant();
    }, []);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    const closeSidebar = () => {
        setIsOpen(false);
    };

    const handleSignOut = async () => {
        try {
            await Auth.signOut();
            navigate('/');
            window.location.reload();
        } catch (error) {
            console.error('Error signing out:', error);
        }
    };

    // Show at least the sign-out button for authenticated users
    const showMinimalSidebar = !isAdmin && !userGroups.includes(USER_GROUPS.ATENDIMENTOS) && !userGroups.includes(USER_GROUPS.CAIXA);
    
    if (showMinimalSidebar) {
        return (
            <>
                <button className="sidebar-toggle" onClick={toggleSidebar}>
                    {isOpen ? <FaTimes /> : <FaBars />}
                </button>
                <div className={`sidebar ${isOpen ? 'open' : ''} ${isCollapsed ? 'collapsed' : ''}`}>
	                    {tenant && !isCollapsed && (
	                        <div className="tenant-info">
	                            <h3>{tenant.name}</h3>
	                            {userEmail && <p className="tenant-user-email">{userEmail}</p>}
	                        </div>
	                    )}
                    <div className="sidebar-nav-items">
                        {/* Empty nav items for minimal sidebar */}
                    </div>
                    <button className="sidebar-item signout-button" onClick={handleSignOut}>
                        <FaSignOutAlt className="sidebar-icon" />
                        {!isCollapsed && <span>Sair</span>}
                    </button>
                    <button className="collapse-toggle" onClick={toggleCollapse}>
                        {isCollapsed ? <FaChevronRight className="toggle-icon" /> : <FaChevronLeft className="toggle-icon" />}
                    </button>
                </div>
            </>
        );
    }

    return (
        <>
            <button className="sidebar-toggle" onClick={toggleSidebar}>
                {isOpen ? <FaTimes /> : <FaBars />}
            </button>
            <div className={`sidebar ${isOpen ? 'open' : ''} ${isCollapsed ? 'collapsed' : ''}`}>
	                {tenant && !isCollapsed && (
	                    <div className="tenant-info">
	                        <h3>{tenant.name}</h3>
	                        {userEmail && <p className="tenant-user-email">{userEmail}</p>}
	                    </div>
	                )}
                <div className="sidebar-nav-items">
                    {canAccessBooking && (
                        <>
                            <Link to="/agenda/ver" className="sidebar-item" onClick={closeSidebar}>
                                <FaCalendarAlt className="sidebar-icon" />
                                {!isCollapsed && <span>Agendamentos</span>}
                            </Link>
                                    <div style={{ paddingLeft: 20 }}>
                                        <Link to="/agenda/ver" className="sidebar-item" onClick={closeSidebar}>
                                            {!isCollapsed && <span>Ver Agendamentos</span>}
                                        </Link>
                                        <Link to="/agenda/criar" className="sidebar-item" onClick={closeSidebar}>
                                            {!isCollapsed && <span>Criar Agendamento</span>}
                                        </Link>
                                        <Link to="/agenda/bloqueios" className="sidebar-item" onClick={closeSidebar}>
                                            {!isCollapsed && <span>Bloqueios de Agenda</span>}
                                        </Link>
                                        <Link to="/agenda/relatorio" className="sidebar-item" onClick={closeSidebar}>
                                            {!isCollapsed && <span>Relatório</span>}
                                        </Link>
                                    </div>
                        </>
                    )}
                    {canAccessPacientes && (
                        <>
                            
                            <Link to="/pacientes" className="sidebar-item" onClick={closeSidebar}>
                                <FaUserFriends className="sidebar-icon" />
                                {!isCollapsed && <span>Pacientes</span>}
                            </Link>
                        </>
                    )}
                    {canAccessCaixa && (
                        <>
                            <Link to="/financeiro" className="sidebar-item" onClick={closeSidebar}>
                                <FaCashRegister className="sidebar-icon" />
                                {!isCollapsed && <span>Financeiro</span>}
                            </Link>
                            {isAdmin && (
                                <>
                                    <Link to="/fluxo-caixa" className="sidebar-item" onClick={closeSidebar}>
                                        <FaChartBar className="sidebar-icon" />
                                        {!isCollapsed && <span>Fluxo de caixa</span>}
                                    </Link>

                                    <Link to="/prontuario" className="sidebar-item" onClick={closeSidebar}>
                                    <FaNotesMedical className="sidebar-icon" />
                                    {!isCollapsed && <span>Prontuário</span>}
                                    </Link>
                                </>
                            )}
                            <Link to="/reports" className="sidebar-item" onClick={closeSidebar}>
                                <FaChartBar className="sidebar-icon" />
                                {!isCollapsed && <span>Relatórios</span>}
                            </Link>
                            <Link to="/estoque" className="sidebar-item" onClick={closeSidebar}>
                                <FaBoxes className="sidebar-icon" />
                                {!isCollapsed && <span>Estoque</span>}
                            </Link>
                        </>
                    )}
                    {/* {canAccessNexusAI && (
                        <Link to="/nexusai" className="sidebar-item" onClick={closeSidebar}>
                            <FaRobot className="sidebar-icon" />
                            {!isCollapsed && <span>NexusAI</span>}
                        </Link>
                    )} */}
                    <Link to="/config" className="sidebar-item" onClick={closeSidebar}>
                        <FaCog className="sidebar-icon" />
                        {!isCollapsed && <span>Configurações</span>}
                    </Link>
                    {isAdmin && (
                        <Link to="/users" className="sidebar-item" onClick={closeSidebar}>
                            <FaUsers className="sidebar-icon" />
                            {!isCollapsed && <span>Usuários</span>}
                        </Link>
                    )}
                </div>
                <button className="sidebar-item signout-button" onClick={handleSignOut}>
                    <FaSignOutAlt className="sidebar-icon" />
                    {!isCollapsed && <span>Sair</span>}
                </button>
                <button className="collapse-toggle" onClick={toggleCollapse}>
                    {isCollapsed ? <FaChevronRight className="toggle-icon" /> : <FaChevronLeft className="toggle-icon" />}
                </button>
            </div>
        </>
    );
}

export default Sidebar;
